// Only Master Products / Master Variants are selectable for bulk actions (PCS-11321) — listings
// and listing variants render in the same grid but never get a checkbox.
export const SELECTABLE_TYPES = new Set(['master', 'masterVariant']);

export const isSelectableItem = (item) => Boolean(item) && SELECTABLE_TYPES.has(item.type);

// A bare `_id` can't tell a master product apart from a master variant that happens to share an
// id space with something else in the grid — the key carries the type explicitly.
export const buildSelectionKey = (item) => `${item.type}:${String(item._id)}`;

export const parseSelectionKey = (key) => {
  const separatorIndex = key.indexOf(':');
  return {
    type: key.slice(0, separatorIndex),
    _id: key.slice(separatorIndex + 1),
  };
};
